module.exports = __webpack_public_path__ + "img/cate-5-5978f0.png";